import { render, staticRenderFns } from "./season-view-page.vue?vue&type=template&id=5957946b&"
import script from "./season-view-page.vue?vue&type=script&lang=js&"
export * from "./season-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports